import { AxiosResponse } from 'axios';
import { BASE_URL } from 'src/config/api';
import client from '../client';
import { GlobalBanListResponse } from 'src/admin-entity/interface/global-ban/global-ban-list.interface';
import {
    GlobalBanActionResponse,
    GlobalBanMemoResponse,
} from 'src/admin-entity/interface/global-ban/global-ban-response.interface';

export const fetchGlobalBanList = (nextPage?: string | null): Promise<AxiosResponse<GlobalBanListResponse>> => {
    return client.get(`${BASE_URL}/v1/admin/ls/global/ban`, {
        params: { take: 50, ...(nextPage ? { nextPage } : {}) },
    });
};

export const addGlobalBan = (appUserId: number): Promise<AxiosResponse<GlobalBanActionResponse>> => {
    return client.post(`${BASE_URL}/v1/admin/ls/global/ban`, { appUserId });
};

export const unbanGlobalChatUser = (appUserId: number): Promise<AxiosResponse<GlobalBanActionResponse>> =>
    client.delete(`${BASE_URL}/v1/admin/ls/global/ban/${appUserId}`);

export const updateGlobalBanMemo = (appUserId: number, memo: string): Promise<AxiosResponse<GlobalBanMemoResponse>> => {
    return client.put(`${BASE_URL}/v1/admin/ls/global/ban/${appUserId}/memo`, { banMemo: memo });
};

export const fetchGlobalBanMemo = (appUserId: number): Promise<AxiosResponse<GlobalBanMemoResponse>> => {
    return client.get(`${BASE_URL}/v1/admin/ls/global/ban/${appUserId}/memo`);
};
